/**
 * @cogo/design-presets — shared 6-axis preset table + axes resolver.
 *
 * Single source of truth for the (Style, BaseColor, Theme, Chart, Radius, Font)
 * cascade. Used by:
 *   - cogo-studio   (Studio preview / Design System editor)
 *   - cogo-commerce (per-app theme injection)
 *   - cogo-react-renderer-v2 (runtime: derive themeTokens from
 *     design-system.json::axes when present)
 *
 * Extracted from cogo-studio/src/features/design-system/lib/ to break the
 * Studio→renderer dependency direction (renderer cannot import from an app).
 *
 * The DOM mutators (`applyThemeVars`, `applyStyle`) live alongside the data
 * tables for backward compatibility with existing Studio imports — they are
 * harmless and tree-shakable when the renderer ships without them.
 */

export * from './shadcn-presets'
export * from './font-stacks'
export * from './axes-resolver'
export * from './theme-v2-types';
export * from './verified-library-style-packs'
/**
 * The canonical baseline theme (`cogo:Theme/default-theme-v1`) — the file that
 * declares what the platform provides. Exported so a consumer can READ it
 * rather than keep a hand-copied snapshot of its atom list; `cogo-ds-browser`
 * already carries such a snapshot and it can only drift.
 *
 * Exporting it does not put it on any paint path: `axesToThemeV2` still builds
 * from its own constants. Anything that wants to paint with this must do so
 * deliberately.
 */
export { default as CANONICAL_THEME } from '../themes/default-theme.json';

export {
  resolveTheme,
  resolveThemeCssVarsForScheme,
  DEFAULT_I18N,
} from './theme-resolver';
export type { ResolvedTheme, ThemeColorScheme } from './theme-resolver';
export {
  axesToThemeV2,
  DEFAULT_SPACING,
  DEFAULT_ELEVATION,
  DEFAULT_MOTION,
  DEFAULT_TYPOGRAPHY_SCALE,
  DEFAULT_TYPOGRAPHY_WEIGHTS
} from './axes-to-theme-v2';
